import { Post, Delete } from "./common";

export default class UserService {
  static list = async (token: string, data: any) =>
    await Post({ path: "users/list", token, body: data });

  static getDetailsById = async (token: string, data: any) =>
    await Post({ path: `users/details`, token, body: data });

  static getAll = async (data: any) =>
    await Post({ path: "users", body: data });

  static getAllPublicInfo = async (data: any) =>
    await Post({ path: `users/public`, body: data });

  static reload = async (token: string) =>
    await Post({ path: "users/self", token });

  static register = async (data: any) =>
    await Post({ path: "users/signup", body: data });

  static login = async (data: any) =>
    await Post({ path: "users/login", body: data });

  static loginWithGoogle = async (data: any) =>
    await Post({ path: "users/login-with-google", body: data });

  static signupWithGoogle = async (data: any) =>
    await Post({ path: "users/signup-with-google", body: data });

  static forgotPassword = async (data: any) =>
    await Post({ path: "users/forgot-password", body: data });

  static resetPassword = async (data: any) =>
    await Post({ path: "users/reset-password", body: data });

  static activateAccount = async (data: any) =>
    await Post({ path: "users/activate", body: data });

  static verifyPin = async (data: any) =>
    await Post({ path: "users/verify", body: data });

  static update = async (token: string, data: any) =>
    await Post({ path: "users/update", token, body: data });

  static updateDescription = async (token: string, data: any) =>
    await Post({ path: "users/update-description", token, body: data });

  static updatePicture = async (token: string, data: any) =>
    await Post({ path: "users/update-picture", token, body: data });

  static removePicture = async (token: string) =>
    await Post({ path: "users/remove-picture", token });

  static createPassword = async (token: string, data: any) =>
    await Post({ path: "users/create-password", token, body: data });

  static changePassword = async (token: string, data: any) =>
    await Post({ path: "users/change-password", token, body: data });

  static logoutAll = async (token: string) =>
    await Post({ path: "users/logout-all", token });

  static updateBlockStatus = async (token: string, data: any) =>
    await Post({ path: "users/block", token, body: data });

  static deleteById = async (token: string, id: string) =>
    await Delete({ path: `users/${id}`, token });

  static deleteMyAccount = async (token: string, data: any) =>
    await Post({ path: `users/delete-myself`, token, body: data });

  static createEmployee = async (token: string, data: any) =>
    await Post({ path: "users/employee/", token, body: data });

  static getEmployees = async (token: string, data: any) =>
    await Post({ path: "users/employees/", token, body: data });

  static getTopSellers = async (data: any) =>
    await Post({ path: `users/top-sellers`, body: data });

  static getSellers = async (data: any) =>
    await Post({ path: `users/sellers`, body: data });
}
